import { render } from "./CardInfo.vue?vue&type=template&id=50898d6a&scoped=true"
import script from "./CardInfo.vue?vue&type=script&lang=js"
export * from "./CardInfo.vue?vue&type=script&lang=js"

import "./CardInfo.vue?vue&type=style&index=0&id=50898d6a&lang=scss&scoped=true"

import exportComponent from "/Users/amina/Desktop/streamup_amina/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50898d6a"]])

export default __exports__